import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import PersonIcon from "@mui/icons-material/Person";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import PolicyIcon from "@mui/icons-material/Policy";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Atras from "../routes/atras";
import logo from "../imgs/logo.png";
import { useThemeMode } from "../theme/ThemeModeProvider";

const NAV_ITEMS = [
  { label: "Perfil", icon: <PersonIcon fontSize="small" />, href: "/profile" },
  { label: "Términos", icon: <AutoStoriesIcon fontSize="small" />, href: "/terms" },
  { label: "Privacidad", icon: <PolicyIcon fontSize="small" />, href: "/privacyPolicy" },
];

export default function AppHeader({ variant = "app", title, user, onLogout }) {
  const { mode, toggleMode } = useThemeMode();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [menuAnchor, setMenuAnchor] = useState(null);

  const modeToggle = (
    <IconButton color="inherit" onClick={toggleMode} aria-label="Cambiar tema">
      {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
    </IconButton>
  );

  if (variant === "brand") {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4, mb: 1 }}>
        <Box component="img" src={logo} alt="IntelliChallenge" sx={{ width: 88, height: "auto" }} />
        <Typography variant="h6" sx={{ mt: 1, fontWeight: 700, color: "primary.main" }}>
          IntelliChallenge
        </Typography>
      </Box>
    );
  }

  if (variant === "back") {
    return (
      <AppBar position="fixed" color="primary">
        <Toolbar sx={{ gap: 1 }}>
          <Atras />
          <Typography variant="h6" noWrap sx={{ flexGrow: 1, color: "inherit" }}>
            {title}
          </Typography>
          {modeToggle}
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <AppBar position="fixed" color="primary">
      <Toolbar sx={{ gap: 1 }}>
        <MuiLink
          href="/profile"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            color: "inherit",
            textDecoration: "none",
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          {user?.profileImageUrl && (
            <Avatar
              src={user.profileImageUrl}
              alt={user.displayName}
              sx={{ width: 36, height: 36, border: "2px solid rgba(255,255,255,0.6)" }}
            />
          )}
          <Typography variant="subtitle1" noWrap sx={{ color: "inherit" }}>
            Hola, {user?.displayName || "..."}
          </Typography>
        </MuiLink>

        {isMobile ? (
          <>
            {modeToggle}
            <IconButton
              color="inherit"
              onClick={(event) => setMenuAnchor(event.currentTarget)}
              aria-label="Abrir menú"
            >
              <MenuIcon />
            </IconButton>
            <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={() => setMenuAnchor(null)}>
              {NAV_ITEMS.map((item) => (
                <MenuItem
                  key={item.href}
                  onClick={() => {
                    setMenuAnchor(null);
                    navigate(item.href);
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>{item.label}</ListItemText>
                </MenuItem>
              ))}
              {onLogout && (
                <MenuItem
                  onClick={() => {
                    setMenuAnchor(null);
                    onLogout();
                  }}
                >
                  <ListItemIcon>
                    <ExitToAppIcon fontSize="small" color="error" />
                  </ListItemIcon>
                  <ListItemText sx={{ color: "error.main" }}>Cerrar sesión</ListItemText>
                </MenuItem>
              )}
            </Menu>
          </>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {NAV_ITEMS.map((item) => (
              <IconButton
                key={item.href}
                color="inherit"
                onClick={() => navigate(item.href)}
                title={item.label}
              >
                {item.icon}
              </IconButton>
            ))}
            {onLogout && (
              <IconButton color="inherit" onClick={onLogout} title="Cerrar sesión">
                <ExitToAppIcon />
              </IconButton>
            )}
            {modeToggle}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
